function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9048"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8061"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 748",
    d: "M639.2 380.49a2.822 2.822 0 0 1-2.794-2.515.815.815 0 0 1-.005-.093v-8.141h1.746v8.087a1.07 1.07 0 0 0 .957.909h.506a1.325 1.325 0 0 0 1.183-.977v-13.041a.874.874 0 0 1 .873-.874l16.6.023a.874.874 0 0 1 .872.874v12.151a3.977 3.977 0 0 1-.554 2.4.858.858 0 0 1-.155.191 3.808 3.808 0 0 1-2.286.994h-16.48c-.09 0-.181.005-.272 0-.064.01-.13.012-.191.012zm3.088-1.756h13.8a1.2 1.2 0 0 0 1.073-.453 2.387 2.387 0 0 0 .24-1.347v-11.32l-14.858-.021v12.267a.888.888 0 0 1-.018.181 3.185 3.185 0 0 1-.241.693z",
    transform: "translate(-636.397 -360.845)",
    style: {
      fill: "#175664"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 749",
    d: "M655.1 371.631h-7.8a.874.874 0 0 1 0-1.748h7.8a.874.874 0 0 1 0 1.748z",
    transform: "translate(-637.671 -361.607)",
    style: {
      fill: "#175664"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 750",
    d: "M655.074 376.625h-7.8a.874.874 0 0 1 0-1.748h7.8a.874.874 0 0 1 0 1.748z",
    transform: "translate(-637.667 -362.237)",
    style: {
      fill: "#175664"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.2cb70bee.svg";
export { ForwardRef as ReactComponent };